import { RadioGroup, styled } from '@mui/material';
import { theme } from 'src/assets/theme/theme';

export const StyledRadioButtonGroupBox = styled(RadioGroup)<{ fullwidth: string }>`
  display: flex;
  gap: 20px;
  margin-top: ${theme.spacing(8)};
  flex-direction: row;
  justify-content: ${(props) => (props.fullwidth === 'true' ? 'center' : 'flex-start')};
  flex-wrap: wrap;
`;
